const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(
    previewImage,
    [165, 360, 533, 720, 940, 1066]
  );
  newImage.loading = "lazy";
  return newImage;
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          wrapper
            .querySelector(".js-color-swatches-link")
            .setAttribute("href", event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper
              .querySelector('.card__add-to-cart button[name="add"]')
              .setAttribute("aria-disabled", false);
            if (
              wrapper.querySelector(
                '.card__add-to-cart button[name="add"] > span'
              )
            ) {
              wrapper
                .querySelector('.card__add-to-cart button[name="add"] > span')
                .classList.remove("hidden");
              wrapper
                .querySelector(
                  '.card__add-to-cart button[name="add"] .sold-out-message'
                )
                .classList.add("hidden");
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
              event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          jQuery.getJSON(
            window.Shopify.routes.root + `products/${handleProduct}.js`,
            function (product) {
              const variant = product.variants.filter(
                (item) =>
                  item.featured_media != null &&
                  item.options.includes(currentColor)
              )[0];

              if (variant) {
                const newPrimaryImage = createImageElement(
                  variant["featured_media"],
                  primaryImage.className,
                  primaryImage.sizes,
                  product.title
                );

                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src)
                      .pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src)
                      .pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove("media--second");
                      secondaryImage.classList.add("media--first");
                      flag = true;
                    }
                  }
                  if (flag == false) {
                    primaryImage.animate(
                      { opacity: [1, 0] },
                      { duration: 200, easing: "ease-in", fill: "forwards" }
                    ).finished;
                    setTimeout(function () {
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate(
                        { opacity: [0, 1] },
                        { duration: 200, easing: "ease-in" }
                      );
                      if (secondaryImage) {
                        secondaryImage.remove();
                      }
                    }, 200);
                  }
                }
              }
            }
          );
        }
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
};

function enableSwatchHoverImageSwap() {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach((wrapper) => {
    const productImage = wrapper.querySelector('.media--first');
    const productImage2 = wrapper.querySelector('.media--second');
    const sizes = '(max-width: 576px) 100vw, (max-width: 1200px) 50vw, 100vw',widths = [375, 550, 750, 1100, 1500, 1700, 1900];
    if (!productImage) return;
    let originalSrc = null;
    let originalSrcset = null;
    let originalAlt = null;
    let originalSizes = null;
    let originalClass = null;
    wrapper.querySelectorAll('.js-color-swatches label[data-img]').forEach((label) => {
      label.addEventListener('mouseenter', function () {
        const imgUrl = label.getAttribute('data-img');
        if (!imgUrl) return;
        // Save original only on first hover
        if (!originalSrc) {
          originalSrc = productImage.src;
          originalSrcset = productImage.srcset;
          originalAlt = productImage.alt;
          originalSizes = productImage.sizes;
          originalClass = productImage.className;
          originalSrc2 = productImage2.src;
          originalSrcset2 = productImage2.srcset;
          originalAlt2 = productImage2.alt;
          originalSizes2 = productImage2.sizes;
          originalClass2 = productImage2.className;
        }
        // Generate srcset for the hovered image
        const generateSrcset = (src, widths = []) => {
          return widths
            .map((width) => {
              let url = src;
              if (url.includes('?')) {
                url = `${url}&width=${width}`;
              } else {
                url = `${url}?width=${width}`;
              }
              return `${url} ${width}w`;
            })
            .join(', ');
        };
        productImage.src = imgUrl;
        productImage.srcset = generateSrcset(imgUrl.split('&width=')[0], widths);
        productImage.sizes = sizes;
        productImage.alt = label.getAttribute('aria-label') || originalAlt;
        productImage2.src = imgUrl;
        productImage2.srcset = generateSrcset(imgUrl.split('&width=')[0], widths);
        productImage2.sizes = sizes;
        productImage2.alt = label.getAttribute('aria-label') || originalAlt2;
      });
      label.addEventListener('mouseleave', function () {
        if (originalSrc) {
          productImage.src = originalSrc;
          productImage.srcset = originalSrcset;
          productImage.alt = originalAlt;
          productImage.sizes = originalSizes;
          productImage.className = originalClass;
          productImage2.src = originalSrc2;
          productImage2.srcset = originalSrcset2;
          productImage2.alt = originalAlt2;
          productImage2.sizes = originalSizes2;
          productImage2.className = originalClass2;
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', enableSwatchHoverImageSwap);

(function () {
  colorSwatches();
})();
